/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeBackIcon64Regular = forwardRef('ArrowRoundTimeBackIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M22.62 11a23 23 0 1 1-10.952 31.753 1.5 1.5 0 1 0-2.652 1.403A26 26 0 1 0 10 18.144V8a1.5 1.5 0 1 0-3 0v13.25A2.75 2.75 0 0 0 9.75 24H22.5a1.5 1.5 0 0 0 0-3H11.801a23 23 0 0 1 10.818-10Z" })));
});
